import { messageForInline } from './mapping/copyCatalog.en';
import { parseAxiosApiError, parseResponseData } from './parsing/parseApiError';

/**
 * Single entry point for inline error text (cards, toasts, field alerts).
 */
export function getApiErrorMessage(error: unknown, fallback = 'Something went wrong. Please try again.'): string {
  const parsed = parseAxiosApiError(error);
  if (parsed?.message) {
    if (parsed.errorCode) {
      return messageForInline(parsed.errorCode, parsed.message);
    }
    return parsed.message;
  }
  const err = error as { message?: string };
  if (typeof err?.message === 'string' && err.message.trim()) {
    return err.message;
  }
  return fallback;
}

export function getUserFacingMessage(error: unknown, fallback?: string): string {
  const withUser = error as { userFacingMessage?: string };
  if (typeof withUser?.userFacingMessage === 'string' && withUser.userFacingMessage.trim()) {
    return withUser.userFacingMessage;
  }
  return getApiErrorMessage(error, fallback ?? 'Something went wrong. Please try again.');
}

export function attachUserFacingApiError(error: unknown): void {
  if (typeof error !== 'object' || error === null) return;
  const msg = getApiErrorMessage(error);
  (error as { userFacingMessage?: string }).userFacingMessage = msg;
}

/**
 * For `fetch()` error bodies (JSON already parsed) — same normalization as axios errors.
 */
export function getMessageFromResponseData(
  data: unknown,
  httpStatus: number,
  fallback = 'Something went wrong. Please try again.'
): string {
  const n = parseResponseData(data, httpStatus);
  if (n?.message) {
    if (n.errorCode) return messageForInline(n.errorCode, n.message);
    return n.message;
  }
  return fallback;
}
